module.exports = __webpack_public_path__ + "img/kommune-138.b5aa507a.svg";